<template>
  <a-modal
    v-model:visible="showModal"
    class="modalContainer mobile-modal-fullscreen"
    :closable="false"
  >
    <div class="d-flex align-items-center">
      <font-awesome-icon
        size="2x"
        :icon="['fal', 'times']"
        class="show-in-mobile font-black mr-3"
        @click="handleCancel()"
      />
      <h4 class="fw700 font24 gray700 mb-0">Filter</h4>
      <button
        class="fw700 btn font-white p1224 font14 br6 show-in-mobile ml-auto"
        @click="handleApply()"
        :style="{ background: getPrimaryColor() }"
      >
        Apply Filters
      </button>
      <font-awesome-icon
        size="1x"
        :style="{ cursor: 'pointer' }"
        :icon="['fal', 'times']"
        class="hide-in-mobile font-black ml-auto"
        @click="handleCancel()"
      />
    </div>
    <!-- <h4 class="mainHeading fw700">Filter</h4> -->
    <h6 class="subHeading fw700">Recommendations for</h6>
    <div class="checkboxMain">
      <!-- <a-checkbox
          v-model:checked="checkAll"
          :indeterminate="indeterminate"
          @change="onCheckAllChange"
        >
          All
        </a-checkbox>
        <a-checkbox-group
          v-model:value="answerArray"
          name="checkboxgroup"
          :options="filterOptions"
          class="checkbox"
        /> -->

      <a-radio-group
        v-model:value="answer"
        v-for="(category, index) in categories"
      >
        <a-radio :value="category">{{ category }}</a-radio>
      </a-radio-group>
    </div>

    <div class="clear-filters" @click="clearfilters">
      <p class="clear-text">Clear filters</p>
    </div>
    <template #footer>
      <div class="footer">
        <a-button class="cancel fw700 btn" key="back" @click="handleCancel()">
          <span class="cancelColor">
            Cancel
          </span>
        </a-button>
        <a-button
          class="apply fw700 btn"
          :style="{ background: getPrimaryColor() }"
          key="submit"
          @click="handleApply()"
        >
          <span class="applyColor">
            Apply Filters
          </span>
        </a-button>
      </div>
    </template>
  </a-modal>
</template>

<script>
export default {
  name: "RecommendedFilterModal",
  props: {
    setCategory: Function,
    answer: String,
  },
  data() {
    return {
      answer: "",
      showModal: false,
      categories: [
        "Physicians",
        "Advanced Practice Providers",
        "Hospitals",
        "Clinics",
        "NFP"
      ]
    };
  },

  methods: {
    Show() {
      this.showModal = true;
    },
    handleCancel() {
      this.showModal = false;
    },

    handleApply() {
      this.handleCancel();
      switch (this.answer) {
        case "Physicians":
          this.answer = "doctor";
          break;
        case "Advanced Practice Providers":
          this.answer = "ohcp";
          break;
        case "Hospitals":
          this.answer = "hospital_administrator";
          break;
        case "Clinics":
          this.answer = "clinic_administrator";
          break;
        case "NFP":
          this.answer = "nfp_administrator";
          break;
        case "Bussiness":
          this.answer = "admin";
          break;
        default:
          this.answer = "";
          break;
      }
      console.log(this.answer);
      this.setCategory(this.answer);
    },
    clearfilters() {
      this.answer = "";
    }
  }
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 426px) {
  .clear-filters {
    display: flex !important;
    justify-content: center;
    align-items: center;
    padding: 12px 24px;
    background: #e2e8f0;
    border-radius: 6px;
    height: 48px;
    margin-top: 24px;
  }
  .clear-text {
    font-weight: 700;
    font-size: 14px;
    line-height: 24px;
    text-align: center;
    color: #47556e;
    margin-bottom: 0px;
  }
  .footer {
    display: none !important;
  }
}

.btn {
  border-radius: 6px;
  font-size: 14px;
  line-height: 24px;
  border: none;
}

.clear-filters {
  display: none;
}
.ant-modal-content {
  border-radius: 8px !important;
}

.fw700 {
  font-weight: 700 !important;
}

.mainHeading {
  font-size: 24px;
  line-height: 32px;
  color: #33415f !important;
}

.subHeading {
  font-size: 16px;
  line-height: 32px;
  color: #647490 !important;
  margin-top: 46.5px;
}

.checkbox,
.checkboxMain {
  display: flex;
  flex-direction: column;
  gap: 24px;
  font-weight: 400;
  font-size: 34px;
  line-height: 21px;
  color: #0f1734 !important;
}

.btn {
  border-radius: 6px;
  font-size: 14px;
  line-height: 24px;
}

.cancel {
  background: #e2e8f0;
  width: 91px;
  height: 48px;

  .cancelColor {
    color: #47556e !important;
  }
}

.apply {
  width: 128px;
  height: 48px;

  .applyColor {
    color: #ffffff !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/RecommendedFilterModal.vue